import React from "react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import { BsCalendar, BsClock } from "react-icons/bs";

function ArticleCarouselCard({ article }) {
  return (
    <Card className="article-carousel-card">
      <div className="article-card-img-wrap article-carousel-img-wrap">
        <img
          src={article.coverImage}
          alt={article.title}
          className="article-carousel-img"
          loading="lazy"
        />
      </div>
      <Card.Body>
        <Card.Title className="article-carousel-title">{article.title}</Card.Title>
        <Card.Text className="article-carousel-description">
          {article.description}
        </Card.Text>
        <div className="article-metadata">
          <span className="article-date">
            <BsCalendar />{" "}
            {new Date(article.date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
          </span>
          <span className="article-read-time">
            <BsClock /> {article.readTime}
          </span>
        </div>
        <Link to={`/articles/${article.id}`} className="article-carousel-link">
          Read article →
        </Link>
      </Card.Body>
    </Card>
  );
}

export default ArticleCarouselCard;
